<template>
  <footer class="block py-4 absolute bottom-0 w-full">
    <div class="container mx-auto px-4">
      <hr class="mb-4 border-b-1 border-blueGray-200" />
      <div class="flex items-center justify-center">
        <div class="text-sm text-blueGray-500 font-semibold py-1 text-center">
          Copyright © {{ date }}
          <a
            href="https://www.abiinteriors.com.au/"
            class="text-blueGray-500 hover:text-blueGray-700 text-sm font-semibold py-1"
          >
            ABI
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      date: new Date().getFullYear()
    };
  }
};
</script>
